import classNames from "classnames"

import { formatPhoneNumber } from "utils/formatPhoneNumber"

import styles from "../../../assets/scss/index.module.scss"

interface Props {
  placeholder?: string
  label?: string
  errorMessage?: string
  className?: string
  value?: string
  name?: string
  autoComplete?: string
  id?: string
  autoFocus?: boolean
  disabled?: boolean
  onChange?: (value: string) => void
  onFocus?: () => void
  onBlur?: () => void
}

export const InputPhone = ({
  placeholder,
  label,
  autoComplete,
  errorMessage,
  className,
  value,
  autoFocus,
  name,
  id,
  disabled,
  onChange,
  onFocus,
  onBlur,
}: Props) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, "")

    if (value.length > 10) {
      value = value.slice(0, 10)
    }

    const formattedPhone = formatPhoneNumber(value)
    onChange?.(formattedPhone)
  }

  return (
    <div className={classNames(styles.fieldWrapper, className)}>
      {label && <div className={styles.fieldLabelNew}>{label}</div>}
      <div className={styles.field}>
        <input
          className={classNames(styles.inputNew, {
            [styles.error]: errorMessage,
          })}
          type={"text"}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          value={value}
          name={name}
          id={id}
          autoComplete={autoComplete}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={handleInputChange}
        />
      </div>
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
    </div>
  )
}
